import React from 'react';

const BlankLoader = () => (
  <div />
);

export default BlankLoader;
